module.exports = __webpack_public_path__ + "img/TUNI_logo.06f9a5c6.svg";